import * as types from './actionTypes';

export const fetchPayrollAllowance = (payload) => ({
  type: types.FETCH_PAYROLL_ALLOWANCE_REQUEST,
  payload,
});

export const savePayrollAllowance = (payload) => ({
  type: types.SAVE_PAYROLL_ALLOWANCE_REQUEST,
  payload,
});

export const removePayrollAllowance = (payload) => ({
  type: types.REMOVE_PAYROLL_ALLOWANCE_REQUEST,
  payload,
});

export const fetchPayrollAllowancesDropdown = (unit_id, type_id) => ({
  type: types.FETCH_PAYROLL_ALLOWANCES_DROPDOWN_REQUEST,
  payload: { unit_id, type_id },
});

export const getMonthlyAllowanceTemplate = (payload) => ({
  type: types.FETCH_PAYROLL_ALLOWANCES_TEMPLATE_REQUEST,
  payload,
});


export const allowancelistImport = (payload) => ({
  type: types.PAYROLL_DEDUCTION_ALLOWANCE_IMPORT,
  payload,
});